import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import MainContainer from "../../../layout/MainContainer";
import { useLocation, useNavigate } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useState } from "react";
import useTranslation from "../../../hooks/Translation";

const AddSubCategories = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [category, setCategory] = useState<string>("");

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(0);
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const translate=useTranslation();
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };
  return (
    <>
      <MainContainer>
        <div className="main_loyout">
          <div className="dashboard">
            <h1> {translate?.main?.Add}  {translate?.main?.SubCategory}</h1>
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories/sub-categories");
              }}
            >
             {translate?.main?.Back}
            </Button>
          </div>
          <Card className="cards">
            <form>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label"> {translate?.main?.Image}</Typography>
                    {image ? (
                      <div className="upload_image_preview category_icon_upload">
                        <CardMedia
                          component="img"
                          image={image}
                          alt="photo"
                          sx={{
                            backgroundColor: "transparent",
                            background: "transparent",
                          }}
                        />
                        <CancelIcon
                          onClick={() => {
                            setImage("");
                            setFileName("");
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={(
                              event: ChangeEvent<HTMLInputElement>
                            ) => {
                              const files = (event.target as HTMLInputElement)
                                .files;
                              if (files && files[0].type.includes("image")) {
                                setFileName(files[0].name);
                                setImage(URL.createObjectURL(files[0]));
                              } else {
                                setAlertType(0);
                                setShowAlert(true);
                                setAlertMessage(
                                  "This field only accepts images."
                                );
                              }
                            }}
                          />
                          <Button
                            component="span"
                            className="upload_image_btn category_icon_upload"
                          >
                            <span className="category_icon_placeholder">
                              <CameraAltIcon />
                            </span>
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>
                  {state === "GOAL" ? (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                      {translate?.dashboard?.Select}  {translate?.main?.Category}
                      </Typography>
                      <FormControl sx={{ width: "100%" }}>
                        <Select
                          className="select_div"
                          fullWidth
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={category}
                          inputProps={{
                            "aria-label": "Without label",
                          }}
                          displayEmpty
                          onChange={handleCategoryChange}
                        >
                          <MenuItem value="" disabled>
                          {translate?.dashboard?.Select}
                          </MenuItem>
                          <MenuItem value="cat1"> {translate?.main?.Category} 1</MenuItem>
                          <MenuItem value="cat2"> {translate?.main?.Category} 2</MenuItem>
                          <MenuItem value="cat3"> {translate?.main?.Category} 3</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {state === "GOAL" ? (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                      {translate?.main?.SubCategory}  {translate?.main?.Name}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type={"text"}
                        name="title"
                        variant="outlined"
                        fullWidth
                        placeholder="Sub-category Name"
                      />
                    </Grid>
                  ) : (
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">
                      {translate?.main?.Category}  {translate?.main?.Name}
                      </Typography>
                      <TextField
                        hiddenLabel
                        type={"text"}
                        name="title"
                        variant="outlined"
                        fullWidth
                        placeholder="Category Name"
                      />
                    </Grid>
                  )}
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                     {translate?.main?.Save}
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddSubCategories;
